import { Wrap } from './styles';

import ButtonTooltip from '../../ButtonTooltip';

/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 * 
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useModule, useMap } from 'views/MapView/hooks';

/**
 * Icone de uma lupa com um menor que '<' no meio
 * Usado para voltar um enquadramento anterior
 */
const BackIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.97112 1.84714C8.28164 1.84714 8.59216 1.86931 8.90087 1.91179C8.82144 1.90071 8.7402 1.88963 8.66076 1.87854C9.25833 1.96351 9.84146 2.12606 10.3975 2.36434C10.3253 2.33294 10.2531 2.30153 10.1827 2.27198C10.7279 2.50841 11.2388 2.81503 11.7082 3.1863C11.6468 3.13828 11.5872 3.09025 11.5259 3.04223C11.9844 3.40796 12.3978 3.8291 12.7553 4.29827C12.7084 4.23547 12.6614 4.17451 12.6145 4.11171C12.9774 4.59196 13.2789 5.11839 13.5099 5.67807C13.4792 5.60418 13.4486 5.5303 13.4197 5.45826C13.6544 6.03272 13.815 6.63488 13.8963 7.24997C13.8855 7.16869 13.8746 7.08557 13.8638 7.0043C13.9432 7.62124 13.9432 8.24741 13.8638 8.8662C13.8746 8.78492 13.8855 8.7018 13.8963 8.62053C13.815 9.23747 13.6544 9.83963 13.4197 10.4122C13.4504 10.3384 13.4811 10.2645 13.5099 10.1924C13.277 10.7521 12.9774 11.2785 12.6145 11.7588C12.6614 11.696 12.7084 11.635 12.7553 11.5722C12.3978 12.0414 11.9862 12.4644 11.5259 12.8283C11.5872 12.7802 11.6468 12.7322 11.7082 12.6842C11.2388 13.0536 10.7279 13.3602 10.1827 13.5985C10.2549 13.5671 10.3271 13.5357 10.3975 13.5062C9.84146 13.7444 9.25833 13.9088 8.66076 13.992C8.7402 13.9809 8.82144 13.9698 8.90087 13.9587C8.28525 14.0418 7.6606 14.0437 7.04317 13.9587C7.1226 13.9698 7.20384 13.9809 7.28328 13.992C6.68751 13.9088 6.10438 13.7463 5.55014 13.508C5.62235 13.5394 5.69457 13.5708 5.76498 13.6004C5.22337 13.3658 4.71426 13.061 4.24668 12.6934C4.30806 12.7415 4.36763 12.7895 4.42902 12.8375C3.96143 12.4662 3.54078 12.0359 3.17791 11.5574C3.22485 11.6203 3.27178 11.6812 3.31872 11.744C2.96126 11.2675 2.66338 10.7447 2.4323 10.1906C2.46299 10.2645 2.49368 10.3383 2.52256 10.4104C2.28967 9.84332 2.1308 9.2467 2.04956 8.63715C2.06039 8.71843 2.07123 8.80155 2.08206 8.88282C1.99901 8.25295 1.99901 7.61385 2.08206 6.98398C2.07123 7.06526 2.06039 7.14838 2.04956 7.22965C2.1308 6.6201 2.28967 6.02348 2.52256 5.45641C2.49187 5.5303 2.46118 5.60418 2.4323 5.67622C2.66158 5.12209 2.95946 4.6012 3.31872 4.12279C3.27178 4.1856 3.22485 4.24655 3.17791 4.30935C3.54078 3.83095 3.96143 3.40057 4.42902 3.0293C4.36763 3.07732 4.30806 3.12535 4.24668 3.17337C4.71246 2.80765 5.22337 2.50287 5.76498 2.26644C5.69276 2.29784 5.62055 2.32924 5.55014 2.3588C6.10438 2.12052 6.68751 1.95797 7.28328 1.87485C7.20384 1.88593 7.1226 1.89702 7.04317 1.9081C7.35007 1.86931 7.6606 1.84714 7.97112 1.84714C8.2022 1.84714 8.44592 1.7437 8.61021 1.57746C8.76728 1.41676 8.88462 1.15447 8.87379 0.923583C8.86296 0.685305 8.78714 0.437791 8.61021 0.269703C8.43329 0.103463 8.21664 -0.0018232 7.97112 2.39148e-05C6.49073 0.00187103 5.00131 0.439638 3.76104 1.27084C2.56048 2.07619 1.5549 3.21586 0.957324 4.55502C0.648608 5.24584 0.417523 5.96252 0.314618 6.71615C0.256847 7.13914 0.213518 7.56028 0.217129 7.98881C0.22074 8.41365 0.265874 8.83664 0.329061 9.25779C0.551119 10.7373 1.23896 12.1245 2.20482 13.2402C3.15985 14.3411 4.44165 15.1538 5.82094 15.5639C6.5503 15.78 7.32661 15.8852 8.08666 15.8723C9.01642 15.8575 9.96062 15.6765 10.8218 15.3145C11.2605 15.1298 11.6847 14.9266 12.0855 14.6662C12.443 14.4353 12.7842 14.1693 13.1037 13.8867C13.6905 13.3658 14.196 12.7359 14.6022 12.0599C15.4453 10.6505 15.8479 8.93454 15.6998 7.28691C15.6583 6.83621 15.5933 6.38736 15.4832 5.94775C15.3749 5.51737 15.2214 5.10731 15.0499 4.6991C14.7376 3.9584 14.2953 3.28236 13.7771 2.6765C13.2644 2.07434 12.6434 1.5553 11.9772 1.14154C11.5674 0.886641 11.1287 0.681611 10.681 0.506135C10.2838 0.349129 9.87396 0.230914 9.45512 0.153335C8.96767 0.062826 8.46939 0.00741238 7.97292 0.00556526C7.74184 0.00556526 7.49811 0.109004 7.33383 0.275245C7.17676 0.435944 7.05941 0.698235 7.07025 0.929125C7.08108 1.1674 7.1569 1.41492 7.33383 1.58301C7.50895 1.7437 7.72559 1.84714 7.97112 1.84714Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M12.178 13.5447C12.6401 14.0176 13.1023 14.4905 13.5645 14.9633C14.2975 15.7132 15.0322 16.465 15.7652 17.215C15.9331 17.3867 16.101 17.5585 16.2689 17.7303C16.4332 17.8984 16.6751 18 16.908 18C17.1301 18 17.3936 17.9002 17.5471 17.7303C17.7042 17.5548 17.8215 17.3239 17.8107 17.0764C17.7998 16.8308 17.7186 16.5999 17.5471 16.4225C17.0849 15.9497 16.6228 15.4768 16.1606 15.004C15.4276 14.254 14.6928 13.5022 13.9599 12.7523C13.792 12.5805 13.6241 12.4087 13.4562 12.237C13.2919 12.0689 13.05 11.9673 12.8171 11.9673C12.595 11.9673 12.3314 12.067 12.178 12.237C12.0209 12.4124 11.9036 12.6433 11.9144 12.8908C11.9252 13.1365 12.0047 13.3693 12.178 13.5447Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M9.44812 4.11816L6.77044 7.10481C6.42986 7.48468 6.42986 8.06003 6.77044 8.4399L9.44812 11.4265"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Icone de uma lupa com um maior que '>' no meio
 * Usado para avançar um enquadramento que foi voltado
 */
const ForwardIcon = (props) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.56548 1.84714C8.876 1.84714 9.18652 1.86931 9.49523 1.91179C9.4158 1.90071 9.33456 1.88963 9.25512 1.87854C9.85269 1.96351 10.4358 2.12606 10.9919 2.36434C10.9197 2.33294 10.8474 2.30153 10.777 2.27198C11.3222 2.50841 11.8332 2.81503 12.3026 3.1863C12.2412 3.13828 12.1816 3.09025 12.1202 3.04223C12.5788 3.40796 12.9922 3.8291 13.3497 4.29827C13.3027 4.23547 13.2558 4.17451 13.2088 4.11171C13.5717 4.59196 13.8732 5.11839 14.1043 5.67807C14.0736 5.60418 14.0429 5.5303 14.014 5.45826C14.2487 6.03272 14.4094 6.63488 14.4906 7.24997C14.4798 7.16869 14.469 7.08557 14.4581 7.0043C14.5376 7.62124 14.5376 8.24741 14.4581 8.8662C14.469 8.78492 14.4798 8.7018 14.4906 8.62053C14.4094 9.23747 14.2487 9.83963 14.014 10.4122C14.0447 10.3384 14.0754 10.2645 14.1043 10.1924C13.8714 10.7521 13.5717 11.2785 13.2088 11.7588C13.2558 11.696 13.3027 11.635 13.3497 11.5722C12.9922 12.0414 12.5806 12.4644 12.1202 12.8283C12.1816 12.7802 12.2412 12.7322 12.3026 12.6842C11.8332 13.0536 11.3222 13.3602 10.777 13.5985C10.8492 13.5671 10.9215 13.5357 10.9919 13.5062C10.4358 13.7444 9.85269 13.9088 9.25512 13.992C9.33456 13.9809 9.4158 13.9698 9.49523 13.9587C8.87961 14.0418 8.25496 14.0437 7.63753 13.9587C7.71696 13.9698 7.7982 13.9809 7.87764 13.992C7.28187 13.9088 6.69874 13.7463 6.1445 13.508C6.21671 13.5394 6.28893 13.5708 6.35934 13.6004C5.81773 13.3658 5.30862 13.061 4.84103 12.6934C4.90242 12.7415 4.96199 12.7895 5.02338 12.8375C4.55579 12.4662 4.13514 12.0359 3.77227 11.5574C3.81921 11.6203 3.86614 11.6812 3.91308 11.744C3.55562 11.2675 3.25774 10.7447 3.02666 10.1906C3.05735 10.2645 3.08804 10.3384 3.11692 10.4104C2.88403 9.84332 2.72516 9.2467 2.64392 8.63715C2.65475 8.71843 2.66559 8.80155 2.67642 8.88282C2.59337 8.25295 2.59337 7.61385 2.67642 6.98398C2.66559 7.06526 2.65475 7.14838 2.64392 7.22965C2.72516 6.6201 2.88403 6.02348 3.11692 5.45641C3.08623 5.5303 3.05554 5.60418 3.02666 5.67622C3.25594 5.12209 3.55382 4.6012 3.91308 4.12279C3.86614 4.1856 3.81921 4.24655 3.77227 4.30935C4.13514 3.83095 4.55579 3.40057 5.02338 3.0293C4.96199 3.07732 4.90242 3.12535 4.84103 3.17337C5.30682 2.80765 5.81773 2.50287 6.35934 2.26644C6.28712 2.29784 6.21491 2.32924 6.1445 2.3588C6.69874 2.12052 7.28187 1.95797 7.87764 1.87485C7.7982 1.88593 7.71696 1.89702 7.63753 1.9081C7.94444 1.86931 8.25495 1.84714 8.56548 1.84714C8.79656 1.84714 9.04028 1.7437 9.20457 1.57746C9.36164 1.41676 9.47898 1.15447 9.46815 0.923583C9.45732 0.685305 9.3815 0.437791 9.20457 0.269703C9.02765 0.103463 8.811 -0.0018232 8.56548 2.39148e-05C7.08509 0.00187103 5.59567 0.439638 4.3554 1.27084C3.15484 2.07619 2.14926 3.21586 1.55168 4.55502C1.24297 5.24584 1.01188 5.96253 0.908979 6.71615C0.851207 7.13914 0.807879 7.56028 0.811489 7.98882C0.8151 8.41365 0.860234 8.83664 0.923421 9.25779C1.14548 10.7373 1.83332 12.1245 2.79918 13.2402C3.75421 14.3411 5.03601 15.1538 6.4153 15.5639C7.14466 15.78 7.92097 15.8852 8.68102 15.8723C9.61077 15.8575 10.555 15.6765 11.4161 15.3145C11.8548 15.1298 12.2791 14.9266 12.6799 14.6662C13.0373 14.4353 13.3785 14.1693 13.6981 13.8867C14.2848 13.3658 14.7903 12.7359 15.1965 12.0599C16.0396 10.6505 16.4422 8.93454 16.2942 7.28691C16.2527 6.83621 16.1877 6.38736 16.0775 5.94775C15.9692 5.51737 15.8158 5.10731 15.6443 4.6991C15.3319 3.9584 14.8896 3.28236 14.3715 2.6765C13.8588 2.07434 13.2377 1.5553 12.5716 1.14154C12.1617 0.886641 11.723 0.681611 11.2753 0.506135C10.8781 0.349129 10.4683 0.230914 10.0495 0.153335C9.56203 0.062826 9.06375 0.00741238 8.56728 0.00556526C8.3362 0.00556526 8.09247 0.109004 7.92819 0.275245C7.77112 0.435944 7.65377 0.698235 7.66461 0.929125C7.67544 1.1674 7.75126 1.41492 7.92819 1.58301C8.10331 1.7437 8.31995 1.84714 8.56548 1.84714Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M12.7723 13.5447C13.2345 14.0176 13.6967 14.4905 14.1588 14.9633C14.8918 15.7132 15.6266 16.465 16.3596 17.215C16.5275 17.3867 16.6954 17.5585 16.8633 17.7303C17.0275 17.8984 17.2695 18 17.5024 18C17.7244 18 17.988 17.9002 18.1415 17.7303C18.2985 17.5548 18.4159 17.3239 18.405 17.0764C18.3942 16.8308 18.313 16.5999 18.1415 16.4225C17.6793 15.9497 17.2171 15.4768 16.7549 15.004C16.022 14.254 15.2872 13.5022 14.5542 12.7523C14.3863 12.5805 14.2184 12.4087 14.0505 12.237C13.8862 12.0689 13.6443 11.9673 13.4114 11.9673C13.1894 11.9673 12.9258 12.067 12.7723 12.237C12.6153 12.4124 12.4979 12.6433 12.5088 12.8908C12.5196 13.1365 12.599 13.3693 12.7723 13.5447Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M7.30762 4.11816L9.9853 7.10481C10.3259 7.48468 10.3259 8.06003 9.9853 8.4399L7.30762 11.4265"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Função resonsável por retorna ou avançar nas extensões feitas
 * a partir de dois botões que ficam na toolbar, é possivel retornar
 * a um ponto em que estava e avançar também. 
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns Avança ou retorna nas extensoes.
 */
export const NavigationHistory = ({
  mapContext,
  isActive,
  setIsActive,
  ...props
}) => {
  const [history, setHistory] = useState([]);
  const [future, setFuture] = useState([]);
  const [ignoreEvents, setIgnoreEvents] = useState(false);

  const { getElement } = useModule();
  const { map } = useMap();

  const toolConfig = getElement('CPN-TB-N-NAVIGATION-HISTORY');
  const maxSteps =
    toolConfig?.configuracao?.maxSteps > 0
      ? toolConfig.configuracao.maxSteps
      : 5;

  const listenMove = useCallback(
    ({ target }) => {
      let zoom = target.getZoom();
      let center = target.getCenter();
      let historyItem = {
        zoom,
        center,
      };
      if (!ignoreEvents) {
        setFuture([]);
        setHistory((oldValue) =>
          oldValue.length >= maxSteps
            ? [
                ...oldValue.slice(
                  oldValue.length - (maxSteps - 1),
                  oldValue.length
                ),
                historyItem,
              ]
            : [...oldValue, historyItem]
        );
      }
    },
    [ignoreEvents, maxSteps]
  );

  const moveBack = () => {
    setIgnoreEvents(true);
    setTimeout(() => {
      let newHistory = [...history];
      let historyItem = newHistory.pop();
      let futureItem = {
        zoom: map.getZoom(),
        center: map.getCenter(),
      };
      map.flyTo(historyItem.center, historyItem.zoom);
      setHistory(newHistory);
      setFuture((oldValue) => [...oldValue, futureItem]);
    }, 200);
  };

  const moveForward = () => {
    setIgnoreEvents(true);
    setTimeout(() => {
      let newFuture = [...future];
      let futureItem = newFuture.pop();

      let historyItem = {
        zoom: map.getZoom(),
        center: map.getCenter(),
      };

      map.flyTo(futureItem.center, futureItem.zoom);
      setHistory((oldValue) => [...oldValue, historyItem]);
      setFuture(newFuture);
    }, 200);
  };

  useEffect(() => {
    map.on('movestart', listenMove);
    return () => map.off('movestart', listenMove);
  }, [map, listenMove]);

  // Auto-disable da ferramenta
  useEffect(() => {
    isActive && setIsActive();
  }, [isActive, setIsActive]);

  useEffect(() => {
    const handleMoveEnd = (e) => {
      if (ignoreEvents) {
        setIgnoreEvents(false);
      }
    };
    map.on('moveend', handleMoveEnd);
    return () => map.off('moveend', handleMoveEnd);
  }, [ignoreEvents, map]);

  return (
    <Wrap>
      <ButtonTooltip
        tooltip="Retornar para Extensão Anterior"
        description="Volta à extensão anterior do mapa."
        onClick={() => {
          moveBack();
          setIsActive();
        }}
        disabled={!history.length || ignoreEvents}
      >
        <BackIcon width="17.5" height="18" />
      </ButtonTooltip>
      <ButtonTooltip
        tooltip="Avançar Extensões"
        description="Avança extensões já visualizadas."
        onClick={() => {
          moveForward();
          setIsActive();
        }}
        disabled={!future.length || ignoreEvents}
      >
        <ForwardIcon width="17.5" height="18" />
      </ButtonTooltip>
    </Wrap>
  );
};

NavigationHistory.properties = {
  id: 'CPN-TB-N-NAVIGATION-HISTORY',
  alias: 'Histórico de Navegação',
  description:
    'Volta à extensão anterior do mapa, ou avança extensões já visualizadas',
  configurable: true,
};

export default NavigationHistory;
